import { Button, Table, Form, Input, Select } from "antd";
import { useState } from "react";
import { CountDetailColumns } from "../../data/Columns";
import { owntoast } from "../../utils";
import { EditableCell, EditableRow } from "../TableEditAble";

const MasterRegister = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;
  const handleSubmit = (values) => {
    let details = [];
    if (data) {
      data.map((item, i) => {
        details.push({
          qty: item.text,
          productid: item.id,
          saleprice: item.price,
        });
      });
      values.details = details;
    }
    setLoading(true);
    props
      .request({ url: `/count`, method: "POST", body: values })
      .then((res) => {
        setLoading(false);
        if (res.success) {
          form.resetFields();
          setData([]);
          owntoast(res.message, "success");
        } else {
          owntoast(res.message, "error");
        }
      });
  };

  const selectChanged = (e) => {
    props
      .request({ url: `/product/store/own/${e}`, method: "POST" })
      .then((res) => {
        if (res.success) {
          setData(res.data);
        } else {
          owntoast(res.message, "error");
        }
      });
  };

  const renderStoreList = () => {
    let tmp =
      props.resstore &&
      props.resstore.map((item, i) => {
        return (
          <Option key={i} value={item.id}>
            {item.name}
          </Option>
        );
      });
    return tmp;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleSave = (row) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };

  return (
    <Form onFinish={handleSubmit} loading={loading} form={form}>
      <Form.Item
        name="name"
        rules={[{ message: `Тооллогын нэр уу.`, required: true }]}
      >
        <Input placeholder="Тооллогын нэр" />
      </Form.Item>
      <Form.Item
        name="storeid"
        rules={[{ message: `Дэлгүүр сонгоно уу.`, required: true }]}
      >
        <Select
          showSearch
          optionFilterProp="children"
          placeholder="Дэлгүүр сонгох"
          className="w-full"
          onChange={(e) => selectChanged(e)}
        >
          {renderStoreList()}
        </Select>
      </Form.Item>
      <Table
        scroll={{ x: "80vw", y: "25rem" }}
        loading={loading}
        columns={[
          ...CountDetailColumns,
          {
            title: "Тоо хэмжээ",
            dataIndex: "text",
            key: "text",
            align: "center",
            editable: true,
            width: 200,
            onCell: (record) => ({
              record,
              editable: true,
              dataIndex: "text",
              title: "Тоо хэмжээ",
              handleSave,
            }),
          },
        ]}
        dataSource={data}
        components={components}
        size="small"
        pagination={false}
        className="mt-5"
      />
      <div className="justify-end flex w-full mt-4">
        <Button type="primary" autoFocus htmlType="submit" loading={loading}>
          Хадгалах
        </Button>
      </div>
    </Form>
  );
};

export default MasterRegister;
